import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { ControlContainer, FormGroupDirective, ReactiveFormsModule } from '@angular/forms';
import { Select } from 'primeng/select';
import { InputText } from 'primeng/inputtext';
import { MunicipioPickerComponent } from '../../components/municipio-picker/municipio-picker';

@Component({
    selector: 'app-localizacao',
    standalone: true,
    imports: [ReactiveFormsModule, Select, InputText, MunicipioPickerComponent],
    templateUrl: './localizacao.html',
    viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
    changeDetection: ChangeDetectionStrategy.OnPush
})
/** Seção de formulário de localização/naturalidade. */
export class LocalizacaoComponent {
    modoEdicao = input<boolean>(false);
    carregandoDominios = input<boolean>(false);
    opcoesNacionalidade = input<{ label: string; value: string | number | boolean | null }[]>([]);
    opcoesPaises = input<{ label: string; value: string | number | boolean | null }[]>([]);
    paisEhBrasil = input<boolean>(false);
}
